var React = require('react');

function Rocket (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#2185D0","strokeWidth":"10","transform":"translate(6 7)","key":1},[React.createElement("circle",{"cx":"83","cy":"96","r":"14","key":0}),React.createElement("path",{"d":"M63 244l-14-24-25 14-24-63 18-30C7 93 29 46 83 0c53 46 75 93 64 141l18 30-24 63-25-14-14 24H63z","key":1})])]);
}

Rocket.defaultProps = {"viewBox":"0 0 177 256"};

module.exports = Rocket;

Rocket.default = Rocket;
